import styled from "styled-components";

export const TournamentItmWrapper = styled.div`
  margin: 20px 16px;

  > .header {
    font-weight: 700;
    font-size: 20px;
    line-height: 100%;
  }
`;
export const TournamentItmBack = styled.div<{
  isItm?: boolean;
  open?: boolean;
}>`
  width: 100%;
  margin-top: 12px;
  border-radius: 12px;
  padding: 20px 15px;
  background: ${(p) => (p.isItm ? "#f0f0f0" : "#fff")};
  opacity: ${(p) => (p.open || p.isItm ? "1" : "0")};
  transition: opacity 0.3s ease-in-out;
`;

export const TournamentItmTable = styled.div<{
  isHeight: boolean;
  isItm?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  ${(p) =>
    p.isHeight ? (p.isItm ? "min-height: 346px;" : "min-height: 378px;") : ""}
  margin-bottom: 22px;
`;

export const TournamentTableItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  > .no-data {
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    margin-top: 10px;
  }
`;

export const TournamentItmTableHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 27px;
  border-radius: 10px;
  padding: 5px 10px;

  > .item {
    flex: 1;
    color: #000;
    font-weight: 600;
    font-size: 12px;
    text-align: center;
    border-right: none;

    &:first-child {
      border-right: 1px solid #f0f0f0;
    }
  }
`;

export const TournamentItmItem = styled.div`
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  color: #121212;
  font-size: 14px;
  font-weight: 700;
  background: #fff;
  height: 46px;
  padding: 10px 12px;
  border-radius: 8px;

  > .info {
    display: flex;
    align-items: center;
    gap: 10px;

    > .rank {
      width: 32px;
      text-align: center;
    }
  }
`;

export const TournamentSinInItem = styled.div`
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  color: #121212;
  font-size: 14px;
  font-weight: 700;
  height: 46px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #f0f0f0;

  > .item {
    text-align: center;
    flex: 1;
  }
`;

export const TournamentSininWrapper = styled.div<{
  open: boolean;
  contentHeight: number;
}>`
  background: #f0f0f0;
  width: 100%;
  border-bottom: 1px solid #d9d9d9;
  min-height: 54px;
  padding: 12px 16px;
  height: ${(p) => (p.contentHeight ? `${p.contentHeight}px` : "56px")};
  transition: height 0.5s ease-in-out;
  overflow: hidden;

  > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > .title {
      font-weight: 700;
      font-size: 16px;
    }

    img {
      rotate: ${(p) => (p.open ? "180deg" : "0")};
      transition: all 0.2s ease-in-out;
    }
  }
`;
